import { SAVED_SCATTER_PLOT_REQUEST_KEYS } from 'ChartApp/ts/apps/scatter-plot/state/constants';
import { SCATTER } from 'NewAngular/constants/core.constants';
import { BaseSavedItemService } from 'NewAngular/features/components/saved-items/services/common-services/base-saved-item.service';
import { SavedChartService } from 'NewAngular/features/components/saved-items/services/common-services/saved-chart.service';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { convertNestedBooleanToString } from 'NewAngular/utils/state-utils';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/features/components/saved-items/services/common-services/saved-chart.service";
import * as i2 from "NewAngular/services/core/ajax.service";
import * as i3 from "NewAngular/services/core/urls.service";
export class SavedScatterPlotService extends BaseSavedItemService {
    constructor(savedChartService, ajaxService, urlsService) {
        super();
        this.savedChartService = savedChartService;
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getItems(includeLegacy) {
        return this.savedChartService.getItems(SCATTER, includeLegacy);
    }
    getFolderableItems(params) {
        return this.ajaxService.getDataObserveBody(this.urlsService.CHARTS.SCATTER_PLOT_COLLECTION, params);
    }
    deleteItem(chartId) {
        return this.savedChartService.deleteItem(chartId, SCATTER);
    }
    updateItem(chartId, putParams) {
        const flattenedParams = formFlattenedObject(putParams, SAVED_SCATTER_PLOT_REQUEST_KEYS);
        // Convert booleans to strings because the backend expects booleans to be in the format of strings 'True' or
        // 'False'.
        convertNestedBooleanToString(flattenedParams);
        return this.savedChartService.updateItem(chartId, flattenedParams, SCATTER);
    }
    createItem(initialPostParams, chartName) {
        const postParams = { ...initialPostParams, chartName };
        const flattenedParams = formFlattenedObject(postParams, SAVED_SCATTER_PLOT_REQUEST_KEYS);
        return this.savedChartService.createItem(flattenedParams, SCATTER);
    }
    getErrorMessage(error) {
        return this.savedChartService.getErrorMessage(error);
    }
}
SavedScatterPlotService.ɵfac = function SavedScatterPlotService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SavedScatterPlotService)(i0.ɵɵinject(i1.SavedChartService), i0.ɵɵinject(i2.AjaxService), i0.ɵɵinject(i3.UrlsService)); };
SavedScatterPlotService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SavedScatterPlotService, factory: SavedScatterPlotService.ɵfac, providedIn: 'root' });
